import React from 'react';
import { BsTwitter, BsInstagram, BsLinkedin, BsGithub } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';


const SocialMedia = () => {
      return (
            <div className='app__social'>
                  <div>
                        <a href="https://github.com/losziad" target="_blank">
                              <BsGithub />
                        </a>
                  </div>
                  <div>
                        <a href="https://www.linkedin.com/in/ziad-ayman-b776b91ba/" target="_blank">
                              <BsLinkedin />
                        </a>
                  </div>
                  <div>
                        <a href="https://www.facebook.com/profile.php?id=100008518697466" target="_blank">
                              <FaFacebookF />
                        </a>
                  </div>
            </div>
      )
}

export default SocialMedia